import React from "react";
import { FaBrain, FaFlask } from "react-icons/fa";
import { BiRocket } from "react-icons/bi";
import { BsClipboardData } from "react-icons/bs";

import ProfileSide from "../images/MA_FotoLinkedin_Side_cropped.png";

const homeConfig = {
  greeting_i18n: {
    en: (
      <h1 className="heading">
        Hi! I'm <strong className="main-name"> Martín Antúnez</strong>
      </h1>
    ),
    es: (
      <h1 className="heading">
        ¡Hola! Soy <strong className="main-name"> Martín Antúnez</strong>
      </h1>
    ),
  },

  titles_i18n: {
    en: [
      "Healthcare AI & Data Scientist",
      "PhD | Neuroscientist",
      "Data / MLOps / AI Engineer",
      "Microsoft Certified | Azure & Fabric",
    ],
    es: [
      "Científico de Datos de Salud e IA",
      "PhD | Neurocientífico",
      "Ingeniero de Datos / MLOps / IA",
      "Certificado Microsoft | Azure & Fabric",
    ],
  },

  about_i18n: {
    en: {
      start:
        "I've been working for over nine years on data science and ML projects across academia and industry. I'm excited by learning new things, contributing to the data science community, and spreading the word of data!",
      exit:
        "I'm fluent at Python, SQL databases, BI tools, and more, with a deep interest in machine learning and MLOps.",
    },
    es: {
      start:
        "He trabajado por más de nueve años en proyectos de ciencia de datos y ML en academia e industria. Me entusiasma aprender cosas nuevas, contribuir a la comunidad y compartir conocimiento.",
      exit:
        "Domino Python, bases de datos SQL, herramientas de BI y más, con un fuerte interés en el aprendizaje automático y MLOps.",
    },
  },

  workTimeline: [
    {
      id: "work-3",
      title_i18n: { en: "Data Scientist & MLOps Engineer", es: "Científico de Datos e Ingeniero MLOps" },
      company: "Impacting Digital",
      location: "Porto, Portugal",
      description_i18n: {
        en: "Built and maintained XGBoost churn prediction models (23% reduction), designed scalable ETL pipelines with Azure Data Factory, Databricks and Spark, and integrated Azure OpenAI APIs for automated data enrichment.",
        es: "Construí y mantuve modelos de predicción de churn con XGBoost (reducción del 23%), diseñé pipelines ETL escalables con Azure Data Factory, Databricks y Spark, e integré APIs de Azure OpenAI para enriquecimiento automatizado de datos.",
      },
      date: "2025-Present",
      icon: <BiRocket />,
      tags: ["xgboost", "python", "azure", "adf", "databricks", "spark", "powerbi", "openai", "git"],
    },
    {
      id: "work-2",
      title_i18n: { en: "Data Scientist (Healthcare / Clinical Research)", es: "Científico de Datos (Salud / Investigación Clínica)" },
      company: "DTU Compute, Glostrup Hospital",
      location: "Copenhagen, Denmark",
      description_i18n: {
        en: "Designed a national database for 400,000+ medical records (scalable to 1 PB) and built end-to-end ML pipelines using SVM and XGBoost with PCA to classify schizophrenia risk from multi-modal neural data.",
        es: "Diseñé una base de datos nacional de 400.000+ registros médicos (escalable a 1 PB) y construí pipelines de ML con SVM y XGBoost con PCA para clasificar riesgo de esquizofrenia a partir de datos neurales multimodales.",
      },
      date: "2024-2025",
      icon: <FaBrain />,
      tags: ["python", "matlab", "sql", "ml", "svm", "xgboost", "pca"],
    },
    {
      id: "work-1b",
      title_i18n: {
        en: "Assistant Research Professor",
        es: "Profesor Asistente de Investigación",
      },
      company: "Child Development Laboratory, UMD",
      location: "Maryland, USA",
      description_i18n: {
        en: "Orchestrated the full data lifecycle for an NIH-funded project spanning 28 national and international sites (5 publications, 2 global conferences). Designed and trained SVM and CNN models on multimodal EEG datasets to predict psychopathology risk in vulnerable populations.",
        es: "Orquesté el ciclo de vida completo de datos para un proyecto NIH en 28 sitios nacionales e internacionales (5 publicaciones, 2 conferencias globales). Diseñé y entrené modelos SVM y CNN sobre datos EEG multimodales para predecir riesgo de psicopatología en poblaciones vulnerables.",
      },
      date: "2023-2024",
      icon: <FaFlask />,
      tags: ["python", "r", "svm", "cnn", "eeg", "ml", "nih"],
    },
    {
      id: "work-1a",
      title_i18n: {
        en: "Postdoctoral Researcher",
        es: "Investigador Postdoctoral",
      },
      company: "Child Development Laboratory, UMD",
      location: "Maryland, USA",
      description_i18n: {
        en: "Led a data management team automating Python, R and Matlab data workflows with real-time quality control, and managed Docker containers on Linux servers.",
        es: "Lideré un equipo de gestión de datos automatizando flujos en Python, R y Matlab con control de calidad en tiempo real, y gestioné contenedores Docker en servidores Linux.",
      },
      date: "2022-2023",
      icon: <FaFlask />,
      tags: ["python", "r", "matlab", "git", "docker", "linux"],
    },
    {
      id: "work-0",
      title_i18n: {
        en: "Research and Teaching Associate",
        es: "Investigador y Docente Asociado",
      },
      company: "NeuroCog, ULL",
      location: "Canary Islands, Spain",
      description_i18n: {
        en: "Designed data collection strategies and performed complex statistical analyses in Python, SPSS and R, authoring 5+ peer-reviewed publications. Supervised 5 researchers and coordinated 6 projects from initiation to completion.",
        es: "Diseñé estrategias de recolección de datos y realicé análisis estadísticos complejos en Python, SPSS y R, publicando 5+ artículos revisados por pares. Supervisé a 5 investigadores y coordiné 6 proyectos de inicio a fin.",
      },
      date: "2018-2022",
      icon: <BsClipboardData />,
      tags: ["python", "r", "spss", "statistics", "research"],
    },
  ],
  profilePicture: ProfileSide,
};

export default homeConfig;
